export const LOCALE_RU = 'ru';

export const LOCALE_EN = 'en';

export const LOCALE_KZ = 'kz';
